export const en = {
  translation: {
    'addEmailSentMsg': "Success! Welcome on the Lexicoscope!",
    'addErrorMsg': "An error occured, please try again later",
    'addLoginTakenMsg': "This login is already taken, please take another one and submit again",
    'addMissingFieldsMsg': "Please fill the missing fields and submit again",
    'addSubCorpus': "Add a sub-corpus",
    'advancedParams': "Advanced parameters (optional)",
    'advancedParamsBtn': "Advanced parameters",
    'affiliation': "Affiliation",
    'alignedLang': "Aligned language (language to which the text is translated)",
    'alignedLangColon': "Aligned language:",
    'asSurfaceOrQueryInstanciationOrIncludingSubTree':"As surface realization, as query instanciation, or as a wrapping subtree",
    'authors': "Authors",
    'authorsNumColon': "Authors number:",
    'backToCorpusSelection': "Back to corpus selection",
    'between0_100':"between 0 and 100",
    'byCorpus': "by corpus",
    'byDoc': "by document",
    'byReal': "by realization",
    'calcEstimatedValues':"In case of corpus sampling, compute an estimated value of overall occurrences",
    'caracteristics': "Caracteristics",
    'categories': "Categories",
    'categoriesColon': "Categories: ",
    'category': "Category",
    'categoryColon': "Category:",
    'close': "Close",
    'collection': "Collection",
    'collectionChoice': "Collection choice",
    'collectionColon': "Collection:",
    'collocate': "Collocate",
    'collOccNum': "Relations with collocate",
    'compare':'Compare',
    'completeResList': "Complete result list",
    'conc': "Concordances",
    'concordancesAndOccurrences':"Concordances and occurrences",
    'confirmSaving': "Confirm saving",
    'cooc': "Co-occurrences",
    'coocNum': "Co-occurrences",
    'coocSpecComparisonBtn':'Collocate specificity comparison',
    'coocComparisonBtn':'Collocate specificity comparison',
    'coocWithNodeOnly':"Collocates only cooccur with #1",
    'corpus': "Corpus",
    'corpusHasBeenSaved': "The corpus definition has been saved",
    'corpusLang': "Corpus language",
    'corpusName': "Corpus name",
    'corpusNameIsNotDefined': "Corpus name is not defined",
    'corpusSelection':'Corpus selection',
    'country': "Country",
    'creationDate': "Creation date",
    'credentialsErrorsMsg': "Credentials error. Please retry or create an account if you don't have one already.",
    'currentCorpusCanBeSavedInYourPersonalDirectoriesOnTheServer': "The current corpus may be saved on the server in your personal directory.",
    'customCorpusDesc': "Define one or more sub-corpora, or partition one thanks to partition keys",
    'customCorpusTitle': "Create your own corpus",
    'description': "Description",
    'detailedDataPolicy': "The data collected in this form will be used by the Lidilem team (Université Grenopble Alpes) to know its user better, and won't be sold to any third party. In accordance with the French law, you can reach to us and we will delete your personnal information.",
    'detailedStats': "Detailed statistics",
    'dispByCorpus': "Dispersion by corpus",
    'dispByReal': "Dispersion by realization",
    'dispColon': "Dispersion:",
    'dispCriterion':"Dispersion criterion",
    'assocMeasure' : "Association measure between collocates",
    'innerCollocs':"Inner association measure computation (may take time)",
    'dispersion': "Dispersion",
    'docMeta': "Document metadata",
    'elapsedTime': "Elapsed time:",
    'email': "Email",
    'estimatedFrequencyColon': "Estimated frequency:",
    'exampleColon': "Example:",
    'exemplesOfAdvancedQueriesColon': "Advanced query examples:",
    'expression': "Expression",
    'features': "Features",
    'FFLTeacher': "French foreign language teacher",
    'filterByAuthors': "Filter by authors...",
    'filterByCategories': "Filter by categories...",
    'filterBySourceLangs': "Filter by source languages...",
    'filterByTitles': "Filter by titles...",
    'filters': "Filters",
    'firstName': "First name",
    'form': "Forme",
    'formLemmaCatOthers':'("w"=>form, "l"=>lemma, "c"=>part-of-speech, "f"=>other features)',
    'formLemmaCatOthersRelsPos':'"w"=>form, "l"=>lemma, "c"=>part-of-speech, "f"=> other features, "r"=> dependency relation, "textP"=> position in text, "divP"=> position in division, "paraP"=>position in paragraph, "sentP"=>position in sentence)',
    'freqByCorpus': "Frequency by corpus",
    'freqByDoc': "Frequency by document",
    'freqByReal': "Frequency by realization",
    'frequency': "Frequency",
    'frequencyColon': "Frequency:",
    'global': "Global",
    'globalParams': "Global parameters",
    'go': "Go",
    'goToQuery': "Go to query!",
    'graphicalRepr': "Graphical representation",
    'IAgreeToTerms': "I read and agreed to the terms of use.",
    'id': "Identifier",
    'inSec':"(in seconds)",
    'instancesNumColon': "Instance number:",
    'keyCaracteristics': "Key caracteristics",
    'KWIC/Unfolded': "KWIC/Unfold",
    'kwicCentralFormat':"Kwic central column format",
    'kwicDisplay':"KWIC displaying",
    'langColon': "Language:",
    'language': "Language",
    'LanguageIsNotDefined': "Corpus langage has not been defined",
    'largeContext' : "Broad context",
    'leftContext': "Left context",
    'lemma': "Lemma",
    'lexicalClassDefinition':"Lexical class definition (regular expressions)",
    'lexicalClasses':"Lexical Classes",
    'logIn': 'Login',
    'logLike': "Log-like",
    'logOut': 'Log Out',
    'name': "Name",
    'nbMax2Parse':"Max. number of sentences to parse",
    'nbMaxFound':"Max. number of occurrences to retrieve",
    'node': "Node",
    'noResult': "No result",
    'oneClassPerLine':"One class per line, following the syntax: $CLASSNAME=FORM1|FORM2|...|FORMn",
    'onlyASampleOfTheCorpusHasBeenSearched':"Only a sample of the corpus has been searched. Click here to run the extraction again on the overall corpus (this operation may take a long time, depending on the number of sentences to parse).",
    'other': "Other",
    'overall':"(overall)",
    'partKeys': "Partition keys",
    'partSubCorpus': "Sub-corpus partition",
    'password': 'password',
    'passwordConfirmation': "Password confirmation",
    'percent2Parse':"Percentage of sentences to parse",
    'periodColon': "Period:",
    'phdStudent': "Phd or post-Phd student",
    'pivotOccNum': "Relations with Node",
    'pleaseAddAtLeastOneSubcorpus': "At least one subcorpus must be defined",
    'pleaseLogIn': "Please log-in to access all the features",
    'predefinedCorpus': "Public collections",
    'query': "Query",
    'queryColon': "Query:",
    'selectExistingTexts': "Select texts from existing collections",
    'importYourOwnTexts' : "Import your own texts",
    'querySentColon': "Sent query (TQL) :",
    'queryTimeLimit':"Max. duration for searching",

    'realization': "Realization",
    'realizationDefinition':"Definition of realization for node and collocates",
    'realizationType':"Realization type",
    'recap': "Summary",
    'recapInfo': "Summary",
    'recapSearchAndResults': "Query and results summary",
    'relation': "Relation",
    'relations': "Relations",
    'relevantCollocFeatures':"Relevant collocate features",
    'relevantNodeFeatures':"Relevant node features",
    'relOccNum': "Total number of relations",
    'reset': "Reset",
    'rightContext': "Right context",
    'saveCustomCorpus': "Save the custom corpus",
    'savedCorpusHeader': "Previously saved corpora",
    'scholar': "Scholar",
    'searchArea': "Search beam",
    'searchRecapColon': "Corpus summary:",
    'searchResults': "Search results",
    'searchSpace': "Search space",
    'searchSpaceDefinition': "Search space definition",
    'sentencesParsedColon': "Parsed sentences:",
    'sentencesToParseColon': "Sentences to parse:",
    'ShowMetadata':"Medata of current sentence",
    'signIn': 'Sign In',
    'signUp': 'Sign Up',
    'sourceLangs': "Source languages (original languages of the documents)",
    'sourceLangsColon': "Source language:",
    'specByCorpus': "Specificity by corpus",
    'specByDoc': "Specificity by document",
    'specificity': "Specificity",
    'stats': "Statistics",
    'status': "Status",
    'student': "Student",
    'subCorpusName': "Sub-corpus name",
    'subCorpusParams': "Sub-corpus parameters",
    'successfulSignUpMsg': "You account was successfully created! Please now log-in.",
    'suggestedQueriesExplanation': "Click on one of the suggestions below to generate an advanced query",
    'suggestionOfAdvancedQueries': "Advanced query suggestions",
    'syntaxicTree': "Syntactic tree",
    'syntheticStats': "Global stats",
    'teachingScholar': "Teaching-scholar",
    'terms': "Terms of use",
    'title': "Title",
    'titles': "Titles",
    'tok1OrFull':"(token #1 or full expression)",
    'tokenNumberColon': "Token number:",
    'docNumberColon': "Document number:",
    'paraNumberColon': "Paragraph number:",
    'clsNumberColon': "Clause number:",
    'sentNumberColon': "Sentence number:",    
    'tokenNumColon': "Token number:",
    'tokenNumber': "Token number",
    'formNumber': "Form number",
    'docNumber': "Document number",
    'paraNumber': "Paragraphs number",
    'clsNumber': "Clause number",
    'sentNumber': "Sentence number",
    'formNumberColon': "Form number (except symbols and punctuation) :",
    'nbSentsToParseColon': "Number of sentences to parse:",
    'nbParsedSentsColon': "Number of parsed sents:",
    'tokens': "Tokens",
    'tql': "TQL (Tree query language)",
    'type': 'Type',
    'typeAQuery': "Type a query",
    'useCustomCorpus': "Build your own corpus",
    'usePredefinedCorpus': "Use a predefined collection",
    'useSavedCorpus': "Reuse a saved personalized corpus",
    'validate': "Validate",
    'ws': "Word Sketch",
    'zeroIfNoLimit':"0 for no limit.",
    'whatIsLexicoscope':"What is the Lexicoscope?",
    'intro':"The Lexicoscope, initially called EmoConc, has been developed since 2011 to explore the corpus of the ANR-DFG Emolex project. It is a corpus exploration tool specially dedicated to the exploration of combinatorial profiles of words or expressions, based on syntactic dependencies (for example, verb-subject or verb-object dependency). Version 2.0 of the Lexicoscope has been completely rewritten in order to optimize searches on large textual data and to compare the specificities between different sub-corpora.",
    'strength':"What is the Lexicoscope 2.0 designed for?",
    'strength1':"To give access to large original and multilingual corpora such as PhraseoRom, EmoBase, Scientext.",
    'strength2':"To allow to search complex expression using example based queries.",
    'strength3':"To allow simple comparison between large corpora of various textual genres.",
    'strength4':"To allow saving of custom corpora.",
    'comingSoon':"Coming soon",
    'todo1':"Context clusterisation, time clusterisation, AFC from vocabulary, etc.",
    'todo2':"Graphical user interface for query writing" ,
    'todo3':"Syntactic equations",
    'notaBene':"To access to heavy computation functionalities (RLT, MLM, etc.), you have to ask to the administrator (Olivier.Kraif@univ-grenoble-alpes.fr) a special user status.",
    'testTheTool':"Test the tool",
    'alignedSentence':"Aligned sentence(s)",
    'multivarStats':"Multivariate statistics",
    'specOccStats':"Occurrences by subcorpora",
    'specCoocStats':"Co-occurrences by subcorpora",
    'assocCoocStats':"Co-occurrences by realizations",
    'hclust':"hierarchical ascending clustering",
    'xtab':"Cross table",
    'mds':"Multidimensional scaling",
    'pca':"Principal composant analysis",
    'ca':"Correspondence analysis",
    'distMat':"Distance matrix - Heatmap",
    'dendrogram':"Dendrogram",
    'chart':'Chart',
    'widget1':'Variable 1',
    'widget2':'Variable 2',
    'noTitleIfNotLogged':'To see document titles please signIn.',
    'mainTable':'Main table',
    'vocSize' : "Vocabulary size (types)",
    'TTR' : "Type/Token Ratio (TTR)",
    'vocSizeColon' : "Vocabulary size (types):",
    'TTRColon' : "Type/Token Ratio (TTR):",
    'vocabulary' : "Corpus vocabulary",
    'collocCollig' : "Collocations and colligations",
    'associationMeasure' : "Association measure",
    'specificVocabulary' : "Specific vocabulary",
    'globalStats' : "Global statistics",
    'vocSpecComparison' : "Specificity comparison",
    'globalLemmata' : "Vocabulary - Lemmata",
    'globalPos' : "Vocabulary - Part-of-speech tag",
    'specificLemmata' : "Specific lemmata",
    'specificPos': "Specific tags",
    'totFreq' : "Overall frequency",
    'globalCollocCollig':"Global collocations and colligations",
    'specificCollocCollig':"Specific Collocations and colligations",
    'globalColloc':"Global collocations",
    'specificColloc':"Specific collocations",
    'globalRel':"Global relations",
    'specificRel':"Specific relations",
    'meanAssocSpec' : "Average(Assoc,Spec)",
    'rank' : "Rang",
    'clickedCollocIsTheHead' : "By clicking on one cooccurring lemma, this will be taken as the head in the dependency relation. Results are thus different when clicking on either one or the other lemma.",
    'help' : "Help",
    'videoTutorial' : "Video Tutorial",
    'presentation' : "Overview",
    'simpleQuery' : "Querying simple words",
    'advancedQuery' : "Querying complex expressions",
    'searchSpecificVocabulary' : "Studying specific vocabulary and tags",
    'customCorpus' : "Building a custom corpus",
    'devTeam' : "Development team:",
    'interface' : "Interface (PHP/JS/REACT):",
    'searchEngine' : "Query Engine (Perl):",
    'multivariateAnalysis' : "Multivariate Analyses (Perl,R):",
    'funding' : "Funding:",   
    'termDefinition' : "Term definition",
    'specHelp' : "Specificity indicates whether the frequency of an observation in a sub-corpus deviates from its average frequency in the whole corpus. If the relative frequency observed is much higher than the average relative frequency, the specificity will be high and positive. If it is much lower it will be high and negative. If they are close, specificity measure will be close to 0. It is the Loglike measure that is used here to calculate it.",
    'freqHelp' : "Frequency is the number of times an observation appears in the corpus (or sub-corpus), in absolute value. It is the number of occurrences.",
    'realHelp' : "A realization is the way an abstract pattern is realized on the surface. For example, the pattern <c=ADJ> <l=admiration> can be realized in <l=large,c=ADJ> <l=admiration,c=NOT> or <l=immense,c=ADJ> <l=admiration,c=NOT>.",
    'dispHelp' : "By default, the dispersion indicates the number of documents where the expression appears (document frequency). The dispersion can be calculated according to different criteria, which can be modified in the advanced parameters: year of publication, author, sub-corpus, etc.",
    'runMultivar' : "Run multivariate computation on results",
    'assocHelp' : "An association measure allows to assess the statistical strength of the association between two cooccurring units (the observed co-occurrence frequency is compared with the expected frequency under null hypothesis - assuming that co-occurrence is fortuitous). Here, the computed measure is the pointwise mutual information (PMI). It focuses on co-occurrence between low frequency units. It is complementary to the raw co-occurrence frequency, which focuses on high frequency terms - as loglike does.",
    'aboutCooccurrenceAndWordsketchesTitle' : "About co-occurrences and wordsketches",
    'aboutCooccurrenceAndWordsketches' : "The co-occurrence table displays all cooccurring units whose co-frequency is greater than or equal to 3. The statistics (marginal frequencies, co-frequency, loglike, etc.) are calculated for all dependency relations. The wordsketches synthesize these data by separating the cooccurring units according to the type of dependency, and by selecting only those units for which the loglike exceeds a certain threshold (>=5). Moreover, in order not to overload the display, the wordsketches only record the 15 best cooccurring units (with greater loglike).",
    'udTagSetLink' : "Links to UD tagset documentation",
    'deprel':"Relations (DEPREL)",
    'upos':"Parts-of-speech (UPOS)",    
    'alr' : "ALR",
    'runAlr' : "Run the ALR (Recurring Lexico-syntaxic Tree) computation",
    'firstLevelColloc' : "First Collocate",
    'size' : "Size", 
    'example' : "Example",
    'alrOccNum' : "ALR occurrences",
    'alrSpecComparisonBtn' : "ALR specificity comparison",
    'permalink' : "Permalink",
    'suggest' : "Suggest",
    'suggestExplanation':"To build a complex query, you can enter an expression then click on the [Suggest] button",

    'alrDefinition' : "ALR definition",
    'minSizeMaxSize' : "ALR size [min,max]",
    'sizeHelp' : "Two integers >= 2",
    'freqMinAlr' : "Minimal frequencies at each iteration",
    'freqMinAlrHelp' : "Comma separated integer list",
    'dispMinAlr' : "Minimal dispersion",
    'dispMinAlrHelp' : "Adviced value >= 2",
    'alrInitialization' : "First iteration",
    'collocCatFilter' : "POS filter for initial expansion (at first iteration it is more efficient to look for content words)",
    'collocCatFilterHelp' : "Regular expression",
    'amThreshold' : "Minimum threshold for association measure at the first iteration",
    'alrIterations' : "Iterating parameters",
    'maxNbCollocs' : "Max. number of selected collocates at each step",
    'useCollig' : "If no collocate, look for colligations",
    'alrResult' : "Results",
    'minFreqChildrenRatio4Deduplicating' : "Min. frequency ratio for deduplicating ALR and included sub-ALRs",
    'minFreqChildrenRatio4DeduplicatingHelp' : "[0,1]. 1= no deduplication.",
    'mergeAlr' : "Merge lemmata for similar ALRs",
    
    'generalize' : "Generalization",

    'computationParam' : "Computation parameter",
    'embeddingClassDefinition' : "Lexical class definition using word embeddings",
    'cosSimilarityThreshold' : "Minimal cosinus value for similarity",

    'alrVersion' : `<h4>01/02/2021 : The new ALR version includes the following functionalities: </h4>
      1/ deduplication of sub-ALRs that are included in a longer ALR<br/>
      2/ colligation search when there is no collocate<br/>
      3/ merging similar ALRs in the results.<br/>
      All the parameters are accessible through the Advanced parameter tab.<br/><br/>`,
    'noAlr' : "No ALR found. You may reduce the frequency and dispersion threshold in advanced parameters to get a result.",  

    'update' : "Update stats",

    'ref2cite': "References",
    'reference1' : "Kraif Olivier & Diwersy Sascha (2012). Le Lexicoscope : un outil pour l'étude de profils combinatoires et l'extraction de constructions lexico-syntaxiques. In Actes de la conférence TALN 2012, Grenoble, pp. 399-406.",
    'reference2' : "Kraif Olivier (2019). Explorer la combinatoire lexico-syntaxique des mots et expressions avec le Lexicoscope. In Max Silberstein (dir.), Langue française, N° 203, 67-82.",
    'reference3' : "Sascha Diwersy, Laetitia Gonon, Vannina Goossens, Olivier Kraif, Iva Novakova, Julie Sorba & Ilaria Vidotto (2021). La phraséologie du roman contemporain dans les corpus et les applications de la PhraseoBase, Corpus [En ligne], 22 | 2021, URL : http://journals.openedition.org/corpus/6101 ; DOI : https://doi.org/10.4000/corpus.6101",
    'reference4' : "Kraif Olivier, Novakova Iva & Siepmann Dirk (2019). Multi-Word Expressions and the Construction of Meaning in French and English Crime Fiction. In Flore Coulouma et Cécile Viollain (eds.), Paramétrer le sens en anglais et en français, Marqueurs et structures : articulations et constructions, Paris : Lambert Lucas, 23–38.",

    'realSpecComparisonBtn':'Realization specificity comparison',
    'enlarge':'Enlarge',

    'noWorsketchBeyondTheLoglikeThreshold':'No cooccuring unit beyond the loglike threshold.',
    'minWordSketchLLR' : 'Loglike threshold for selected collocates in wordsketches',
    'maxWordSketchLength' : 'Max. size of collocate lists in wordsketches',
    'wordsketches' : 'Wordsketches',

    'importZipFile' : 'Upload a zip archive or a txt file',
    'selectYourFile' : 'File selection',
    'formatExplanation' : 'Zip format: for each file named XXX.txt, add a file XXX.meta, that contains metadata in TSV format, with lines of the form: attr tab value. Max corpus size: 500 Ko.',
    'contentExplanation' : 'Copy/paste your text directly in the text field (no metadata required). Max corpus size: 500 Ko.',
    'importUsingUpload' : 'Import by uploading files',
    'uploadFile' : 'Send',


    'lemmatizeExample' : 'Lemmatize the suggested query',
    'thanksToHumanum' : ' - This instance of Lexicoscope is gently hosted by TGIR HumaNum.',
    'tokenCreditExhausted': 'The maximum number of tokens is reached. Delete old corpora to free space.',
    'corpusAlreadyExists': 'A corpus with this name already exists. Please chose another name.',
    'importProcessTakesSomeTime':'Corpus processing is running. It may take a few minutes (about one minute to process 30,000 tokens, using Stanza parser)',
    'suppress': 'Delete',
    'confirmSuppressing': 'Confirm deleting',
    'suppressCorpusExplanation': 'This corpus will be deleted with all the associated index files. Be carefull, this operation cannot be canceled.',
    'link2xmlFile': 'Link to the XML file containing the analyzed corpus.',
    'choseContrastCorpusColon': 'Optionally, chose a constrat corpus: ',
    'otherAttr': 'Additional attribute',
    'selectAValueForOtherAttr': 'Values for the additional attribute',
    'metadata': "Metadata",
    'metadataPerDocument': "Metadata per documents",
    'thisValuesAreEstimated' : "These values (in orange color) are estimated (only a sample has been parsed).",
    'runAgain' : "Relaunch on the whole corpus",
    'credits' : "Credits",
    'stanza' : "Imported corpora are parsed using Stanza. Cf. Qi Peng, Zhang Yuhao, Zhang Yuhui, Bolton Jason & Manning Christopher D. (2020) Stanza: A Python Natural Language Processing Toolkit for Many Human Languages. arXiv:2003.07082 (https://nlp.stanford.edu/pubs/qi2020stanza.pdf)",
    'termostat' : "Terminological weights are computed according to a measure given by Patrick Drouin, the TermostatWeb conceptor. Cf. Drouin P. & Doll F. (2008) Quantifying Termhood Through Corpus Comparison. Proc. of Terminology and Knowledge Engineering (TKE-2008)), Copenhagen, 191-206.",
    'source' : "Language 1",
    'target' : "Language 2",
    'unfolded' : "Unfolded view",
    'vocStats' : "Vocabulary",
    'readability' : "Readability",
    'averageClauseLengthToksColon' : "Number of tokens by clause:",
    'averageSentLengthToksColon' : "Number of tokens by sentence:",
    'averageSentLengthFormsColon' : "Number of forms by sentence:",
    'averageWordLengthColon' : "Number of characters by form:",
    'chartComparison' : "Synthesis",
    'subCorpusComparison' : "Subcorpus comparison",
    'lexicalDensityColon' : "Lexical density (content words/all words):",
    'featureStats' : "Morphosyntactic statistics",
    'repet4cat' : "Repetition rate by part-of-speech",
    'averageLength' : "Forms length",
    'averageSentLength' : "Sentence length",
    'averageSentLengthToks' : "Number of tokens by sentence",
    'averageClauseLengthToks' : "Number of tokens by clause",    
    'lexicalDensity' : "Lexical density",
    'repet4catExplanation' : "Repetition rate: this statistics indicates the average number of repetitions of a form or lemma inside of a fixed width span. This average rate is computed for each part-of-speech (content words only).",
    'maxSpanSizeColon' : "Span size (in tokens):",
    'useLemma4RepetColon' : "Computation mode (form or lemma):",
    'filterByCat' : "Filter a given part-of-speech",
    'clickThreeTimesToOpenPopup' : "Click three times on a row to get detailed information about context.",
    'onlySyntax' : "Check in order to compute distance only using syntax (with lexical similarity). Use a lower threshold in this case.",
    'context':"Context",
    'corpusReady':"Validate",
    'extractVocCollig':"Extract indexes (vocabulary and collocations)",
    'specByReal':"Specificity by realization",
    'analogCooc' : "Cooccurrents similar to ",
    'analogCoocExplanation': "Same part-of-speech + semantic similarity using fastext vectors cosinus > 0.55",
    'differentPasswordMsg': "Passwords do not match. Enter them again.",
    'personalData' : "PersonalData",
    'youMustLogInToAccessThisPage':"You must log in to access this page",
    'corpusProcessingIsLong' : "Processing is longer than expected... When the corpus is ready it will appear in the saved corpus list.",
    'otherVersion' : "Other version",
    'diffStats' : "Version comparison (using diff)",
    'statisticsForDiffComparisonBetweenVersions' : "Statistics of different forms between versions",
    'formsThatAppearOnlyIn':"Forms that appear only in",
    'ngrams':"Ngrams",
    'alignedPairs':"Aligned pairs",
    'posTags':"POS tags",
    'posTagsNgrams':"POS tags Ngrams",
    'posTagsAlignedPairs':"Aligned POS tags",        
    'addedOrModifiedToken':"Added or modified token",
    'addedOrModifiedNgram':"Added or modified Ngram", 
    'dataUpdated' : "Data updated !",
    'concordSpan': "Context size (in char.)",
    'fullConcordSpan': "Include neighbouring sentences in the concordance span",
    'chronogram' :"Chronogram",
    'timeStatsExtract': "Compute chronogram (N.B.: space search should be complete enough to get reliable statistics)",
    'timeStatsSpanType' : "Chose a time span type for chronograms",
    'timeStatsSpanLen' : "Chose a time span length for chronograms",
    'timeStatsSpanTypeHelp' : "Y=years, M=months, D=days",
    'timeStatsSpanLenHelp' : "e.g. '3' and 'M' gives a span of 3 months",
    'nbTimeSpan' : "Number of time spans",
    'beginningColon' : "Beginning:",
    'endingColon' : "Ending:",
    'beginning' : "Beginning",
    'ending' : "Ending",
    'freqByTimeId' : "Frequency for each time span",
    'collocTypeByTimeId' : "Number of different collocates (types) for each time span",
    'collocType' : "Number of different collocates (types)",  
    'collocTTR' : "Type / Tokens Ratio for different collocates",      
    'cumFreqByTimeId' : "Cumulated frequency for each time span",
    'specByTimeId' : "Specificity in each time span",
    'timeId': "Time span",
    'timeSpecByTimeId' : "Temporal specificity in each time span",
    'timeSpecificity' : "Temporal specificity",
    'timeSpanSize' : "Time span size (in tokens)",
    'choseRealization' : "Chose a realization",
    'choseColloc' : "Chose a collocate",
    'choseCorpus' : "Chose a subcorpus",
    'occsByRealization' : "Occurrences by realization",
    'occsBySubCorpus' : "Occurrences by subcorpus",
    'occurrences' : "Occurrences",
    'evolutionGlobal' : "Global evolution for all realizations",
    'evolutionForMoreFrequentReal' : "Evolution for the more frequent realisations",
    'play': "Listen to the wav record",
    'info': "Info",
    'subCorpus' : "Subcorpus",
    'filter' : "Filter",
    'filterUsingRegex': "Filtering using a string or a regex",
    'retryToLoadAlr' : "The extraction may not be achieved yet. Try to 'reload' within a few minutes.",
    'reload' : "Reload the results",
    'cumFrequency': "Cumulated frequency",
    'relFrequency' : "Relative freq. (by million)",    
    'coeffExplanation' : "The coeff indicates the frequency ratio between the last and the first period in case of increase, or the inverse ratio in case of decrease.",
    'increasingCollocs' :"Increasing collocates",
    'decreasingCollocs' :"Decreasing collocates",
    'increasingReals' :"Increasing realizations",
    'decreasingReals' :"Decreasing realizations",
    'incDecCollocs' :"Increasing and then decreasing collocates",
    'decIncCollocs' :"Decreasing and then increasing collocates",
    'incDecReals' :"Increasing and then decreasing realizations",
    'decIncReals' :"Decreasing and then increasing realizations",    
    'firstAttestation' : "First attestation",
    'lastAttestion' : "Last attestation",
    'clust' : "Context clustering",
    'clustExplanation' : "A hierarchical clustering algorithm is used (complete-linkage clustering), based on a context similarity measure. To compute this similarity, words that are involved in common syntactic dependencies are compared, using FastText embeddings. Then a Dice is computed to sum all the found similarities (divided by the average number of involved dependencies).",
    'totNbTokColon' : "Total token number:",
    'queryDefinition':'Query definition',

    'tagsetColon' : "Tagset:",
    'genreColon' : "Genre:",

    'warnMixedTagset' : "Warning, corpora have different tagsets. Some queries may work only for a part of the corpora. You may have to use .* for every tags and relations. It is possible to set this in [Advanced parameters/Concordances and occcurrences/Relevant features] in order to remove 'c' feature.",
    'mergeSubCorpora' : "Merge subcorpora for each corpus",
    'unselectAll' : "Unselect all",
    'innerAssoc' : "Internal association measure",
    'assoc' : "Association measure",
    'referenceTQLColon' : "Documentation about TQL query langage:",
    'minNbCooc' : "Minimal cooccurrence frequency in the results",
    'pattern': "Pattern",
    'terminologicWeight': "Terminological weight",  
    'extractPatterns' : "Pattern extraction (for multiword terms)",
    'extractLexicometry' : "Advanced lexicometric data extraction",
    'conllMetadataDefinition' : "Conll metadata definition",
    'idSentPattern' : "Sentence identifier (regex)",
    'timeIntPattern' : "Time interval (regex)",
    'speakerPattern' : "Speaker (regex)",
    'repetitionDefinition' : "Repetition parameter definition",
    'maxSpanSize' : "Span size",
    'useLemma4Repet' : "Using lemmas (vs forms)",
    'lemmaFormatDefinition' : "Lemma format definition",
    'supprUnderScore' : "Underscore suppression for multiword lemmas",
    'import' : "Corpus importation",
    'patternStats' : "Pattern frequency",
    'notEnoughRight' : "This content is copyrighted. It is not possible to display it in extensive form (only short extracts are allowed).",
    'pagePrec': "Previous Page",
    'pageNext': "Next Page",
    'docPrec' : "Previous Document",
    'docNext' : "Next Document",
    'reading' : "Reading",    
    'takeOnlyNodeInRealization' : "Only node word #1 must be taken into account (the rest of the query is just contextual).",
    'validateChanges' : "Validate changes",
    'selectTheCorpusToDisplay':"Select the subcorpus to display",
    'filteringAttr':"Filtering criterion",
    'filteringVal':"Filtering value",
    'metadataFilters' : "Add filters on metadata",
    'addTheCriterion' : "Add the criterion to the query",
    'pos':"Position in doc %",
    'association':"Association measure",
    'colloc':"Collocations",
    'noResultsFor':"No results for ",
    'results':"Results",
    'history':"History",
    'queryHistory':"Query history",
    'clearHistory': "Clear query history",
    'historyIsEmpty': "No query has been recorded",
    'runAlrAgainWithNewParam' : "Run again (with the new parameters if any)",
    'wsByRealization':"Wordsketches by node realization",
    'displayTree':"Display syntactic tree",
    'pasteThisQuery':"Paste this query",
    'orCopyPasteHereTheValuesInTheTextArea':"Or copy/paste the list of values in the textarea below",
    'addTheValues':"Add these values",
    'TTRSpanSize':"Span size for STTR (Standardized Type/Token Ratio)",
    'TTRSpanSizeColon':"Span size for STTR (Standardized Type/Token Ratio):",
    'StanzaModelName':"Name of Stanza model(s) (optional, separated by a comma)",
    'parallelCorpus' : "Parallel corpus",
    'alreadyAligned' : "Already aligned corpus (TXT, TSV or TMX format)",    
    'anErrorHasOccuredDuringImportation' : "An error has occured during importation. Check file formats.",
    'sessionTimeOut': "Session has expired. Thanks to sign in again.",
    'realizations': "Realizations",
    'publicCollections': "Public collections",
    'privateCollections': "Private collections",
    'addCustomCorpus':"Add a private corpus",
    'formatExplanation1': 'Zip format: contains XML-TEI, XML-CONLL, or TXT files. For each XXX.txt file, add a XXX.meta file, containing TSV metadata, with lines in the form: key tab value. Maximum corpus size: 500 Kb',
    'formatExamplesCanBeFindHereColon': 'Format examples can be downloaded from here:',
    'formatExplanation2': 'Zip format: contains TMX, TSV, XML-TEI, XML-CONLL or TXT files. File names must follow the format NAME.L1.EXT, NAME.L2.EXT, NAME.L1-L2.TSV or NAME.L1-L2.TMX or NAME.L1-L2.TSV. For each NAME.L1.TXT file, add a NAME.L1.meta file, containing the TSV metadata, with lines in the form: key tab value. Maximum corpus size: 500 Kb',    'keywords':"Keywords that describe the corpus",
    'keywordsHelp':"Use comma as separator (keywords are usefull to filter corpus displaying)",    
    'currentResultsCanBeSavedInYourPersonalDirectoriesOnTheServer': "The current results may be saved on the server in your personal directory.",
    'saveResults':"Save current results",
    'resultsHaveBeenSaved':"Results have been saved in your personnal space.",    
    'filterHelp':"keyword filtering",
    'savedResults':"Saved results",        
    'suppressResultsExplanation': 'These results will be deleted. Be carefull, this operation cannot be canceled.',
    'savedResultsHeader' : "Previously saved results",
    'cooccurrence' : "Cooccurrence",
    'widenSearch' : "No results : widen research",
    'foundSentsColon' : "Found sentences:",
    'loadingResults' : "Loading results.",
    'initialization' : "Search initialization...",
    'translation' : "Translations",
    'clickOnUnfoldedButtonToSeeParallelCorpus':"Click on 'KWIC/Unfolded' to see the aligned sentences",
    'tokenCreditColon':'Number of tokens that you can import:',
    'choseConstrastCorpusColon': 'Optionnaly, chose a contrast corpus:',
    'eraseContentLemmas':"Erase content lemmas",
    'noCorpusHasBeenSelected':"No corpus has been selected yet in public collection.",
    'chooseDataType':"Choose data type",
    'maxNumberOfLemmasToConsider':"Max number of lemmas to take into account",
    'filteringRegex':'Filtering regex',
    'computeMultivar':'Run on the selected data',
    'value':'Value',
    'anErrorHasOccurred':"An error has occurred...",
    'alreadyParsed':"Corpus already parsed in format XML-CONLL",
    'first5000MoreFrequent':"Selection of 5000 more frequent lemmas",
    'first5000MoreSpecific':"Selection of 5000 more specific lemmas in the sub-corpus",
    'calcContextTree':"Extract contextual trees for context clustering",
    'maxCooc':"Max number of collocates for each realization",
    'computingStatistics':"Computing statistics (may take a long time with the inner association measure computation)...",
    'averageSurf':"Average surface",
    'fullRealOrBytoken':"Choose type of realization",
    'fullRealization':"Full realization", 
    'filterOutUpperCase':"Filter out lemma with uppercase",       
  },
};
